   /*=========================================================================================
  File Name: state.js
  Description: Localization Store Main File
  ----------------------------------------------------------------------------------------
  Item Name: Localization State Module
  Author: Tan Tran
==========================================================================================*/

import state from './state'
//import mutations from './mutations'
//import getters from './getters'
//import actions from './actions'
export default {
    namespaced: true,
    state : state
}